@let _contentComponent = contentComponent();
@let _contentComponentInputs = contentComponentInputs();
@let _contentTemplate = contentTemplate();
@let _contentTemplateContext = contentTemplateContext();
@let _contentString = contentString();

@if (_contentComponent) {
  <ng-container *ngComponentOutlet="_contentComponent; inputs: _contentComponentInputs"></ng-container>
}
@else if (_contentTemplate) {
  <ng-container *ngTemplateOutlet="_contentTemplate; context: _contentTemplateContext"></ng-container>
}
@else if (_contentString) {
  {{_contentString}}
}
